export default ".row {\n\n  display: flex;\n  flex-direction: row;\n  width: 100%;\n  margin-bottom: 20px;\n\n}\n"